import { render, staticRenderFns } from "./LogoFscPfscComponent.vue?vue&type=template&id=0df46691&scoped=true&"
import script from "./LogoFscPfscComponent.vue?vue&type=script&lang=ts&"
export * from "./LogoFscPfscComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df46691",
  null
  
)

export default component.exports